import { useEffect, useState } from "react";
import StyledTable, { ColumnHeader } from "../../../components/table/styled-table";
import BiometricUserTableRow from "./biometric-user-table-row";
import { BiometricDeviceUser } from "../../../service/model/biometric.model";
import { configs } from "../../../app/app-configs";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { fetchBiometricDeviceUsersPage, selectIsLoading } from "../biometric-user.slice";
import { Grid } from "@mui/material";
import SearchBox from "../../../components/search-box";

const headers: ColumnHeader[] = [
    { name: "Device Username" },
    { name: "PIN" },
    { name: "User Type" },
    { name: "Name"},
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly users: BiometricDeviceUser[]
    readonly deviceId: number
}

const BiometricUserTable: React.FC<TableProps> = ({ users, deviceId }) => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(selectIsLoading);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');

    const pageCount = useAppSelector(state => state.biometricUsers.totalPages);

    useEffect(() => {
        dispatch(fetchBiometricDeviceUsersPage({
            pagination: { page: page - 1, size: configs.PAGE_SIZE },
            name: searchText,
            deviceId: deviceId,
        }))
    }, [dispatch, page, searchText, deviceId]);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <>
            <Grid container direction="row" style={{ marginTop: '12px', alignItems: 'center' }}>
                <Grid
                    size={{ lg: 6, md: 12, sm: 12 }}
                    sx={{ width: "100%" }}
                >
                    <SearchBox placeholder="Search by name" setSearchValue={setSearchText} />
                </Grid>
            </Grid>
            <StyledTable headers={headers}
                currentPage={page}
                totalPages={pageCount}
                loading={isLoading}
                emptyMessage="No users found"
                onPageChange={handlePageChange}>

                {users?.map(user =>
                    <BiometricUserTableRow deviceUser={user} key={user.id} />
                )}
            </StyledTable>
        </>
    );
}

export default BiometricUserTable;